import React from 'react';
import classNames from 'classnames';
import { Icons, PrimaryButton } from '../../../components';
import { isArrayLength } from '../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import { getTalentServiceDescription } from '../../../config/configExtras';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';
import { SignatureServiceTypes } from '../../../util/enums';

function SectionAutographs({ selectedSignatureService, providerServices, title, listing }) {
  const {
    typeOfItems,
    photoPrice,
    posterPrice,
    showFanProvidedItemsPrice,
    tradingCardPrice,
    customItems,
  } = providerServices;
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const listingId = listing?.id?.uuid;
  const availableItems = [];

  if (typeOfItems?.photo && photoPrice) {
    availableItems.push({ title: 'Photo', price: photoPrice });
  }
  if (typeOfItems?.poster && posterPrice) {
    availableItems.push({ title: 'Poster', price: posterPrice });
  }
  if (typeOfItems?.showFanProvidedItems && showFanProvidedItemsPrice) {
    availableItems.push({ title: 'Fan Provided Items', price: showFanProvidedItemsPrice });
  }
  if (typeOfItems?.tradingCard && tradingCardPrice) {
    availableItems.push({ title: 'Trading Card', price: tradingCardPrice });
  }
  if (isArrayLength(customItems)) {
    customItems.forEach(item => {
      if (item.price) {
        availableItems.push({ title: item.title, price: item.price });
      }
    });
  }

  const navigateToServiceOfferingsPage = item => {
    const pathname = createResourceLocatorString(
      'ServiceOfferingsPage',
      routeConfiguration,
      { id: listingId, type: SignatureServiceTypes.AUTOGRAPHS },
      {}
    );

    history.push({
      pathname,
      state: { item }, // <-- send item in state
    });
  };

  return (
    <>
      <div className={css.getCustomVideo}>
        <h2>
          {selectedSignatureService?.title}{' '}
          <FormattedMessage id="SectionAutographs.from" values={{ title }} />
        </h2>
      </div>
      {availableItems.length > 0
        ? availableItems.map((item, idx) => (
            <div className={css.bookingSec} key={idx}>
              <div className={classNames(css.offerSec, css.withoutIconSec)}>
                <div className={css.offerContent}>
                  <h2>{item.title}</h2>
                  <p>${Number(item.price).toFixed(2)}</p>
                  <p>
                    {getTalentServiceDescription(item.title) ||
                      'Receive a unique signed item chosen and provided by the talent.'}
                  </p>
                  <PrimaryButton
                    className={css.bookBtn}
                    type="button"
                    onClick={() => navigateToServiceOfferingsPage(item)}
                  >
                    <Icons name="security" />
                    <FormattedMessage id="SectionAutographs.buyNow" />
                  </PrimaryButton>
                </div>
              </div>
            </div>
          ))
        : null}
    </>
  );
}

export default SectionAutographs;
